import { Heart, ImageOff, Plus } from 'lucide-react'
import { formatMoney, thumbUrl } from '@najah/core'
import { Badge, cn } from '@najah/ui'
import type { StoreProduct } from '../lib/api'

export function ProductCard({
  product, onOpen, onAdd, onToggleFavorite,
}: {
  product: StoreProduct
  onOpen: () => void
  onAdd: () => void
  onToggleFavorite?: () => void
}) {
  return (
    <div className="flex flex-col overflow-hidden rounded-xl border border-border bg-surface">
      <button type="button" onClick={onOpen} className="relative aspect-square bg-bg-subtle">
        {product.images[0] ? (
          <img src={thumbUrl(product.images[0]) ?? product.images[0]} alt={product.nameAr} className="size-full object-cover" loading="lazy" />
        ) : (
          <span className="grid size-full place-items-center text-fg-subtle">
            <ImageOff className="size-8" />
          </span>
        )}

        {!product.inStock && (
          <span className="absolute inset-0 grid place-items-center bg-[var(--overlay)]">
            <Badge tone="danger">غير متوفّر</Badge>
          </span>
        )}

        {onToggleFavorite && (
          <span
            role="button"
            tabIndex={0}
            onClick={(e) => { e.stopPropagation(); onToggleFavorite() }}
            onKeyDown={(e) => { if (e.key === 'Enter') { e.stopPropagation(); onToggleFavorite() } }}
            className="absolute top-2 end-2 grid size-8 place-items-center rounded-full bg-surface/90 backdrop-blur-sm"
            aria-label={product.isFavorite ? 'إزالة من المفضّلة' : 'إضافة للمفضّلة'}
          >
            <Heart className={cn('size-4', product.isFavorite ? 'fill-danger text-danger' : 'text-fg-subtle')} />
          </span>
        )}
      </button>

      <div className="flex flex-1 flex-col p-2.5">
        <button type="button" onClick={onOpen} className="text-start">
          <p className="line-clamp-2 text-sm font-medium leading-snug text-fg">{product.nameAr}</p>
          {product.book?.author && (
            <p className="mt-0.5 truncate text-[11px] text-fg-subtle">{product.book.author}</p>
          )}
        </button>

        <div className="mt-auto flex items-center justify-between pt-2">
          <span className="font-bold text-primary" dir="ltr">{formatMoney(product.retailPrice)}</span>
          <button
            type="button"
            onClick={onAdd}
            disabled={!product.inStock}
            className={cn(
              'grid size-8 place-items-center rounded-lg transition-colors',
              product.inStock
                ? 'bg-primary text-fg-on-primary active:brightness-95'
                : 'bg-bg-subtle text-fg-subtle',
            )}
            aria-label="إضافة إلى السلة"
          >
            <Plus className="size-4" />
          </button>
        </div>
      </div>
    </div>
  )
}
